// Custom router file which handles all the SPA routes

import Vue from "vue";
import VueGtm from '@gtm-support/vue2-gtm';
import VueRouter from "vue-router";
import store from "./store";

import LoginPage from "@pages/auth/LoginPage";
import RegisterPage from "@pages/auth/RegisterPage";
import ForgotPasswordPage from "@pages/auth/ForgotPasswordPage";
import PasswordResetPage from "@pages/auth/PasswordResetPage";
import EmailVerifiedPage from "@pages/auth/EmailVerifiedPage";
import CreateAccountPage from "@pages/account/CreateAccountPage";
import Error404Page from "@pages/errors/Error404Page";
import SubmissionSuccessPage from "@pages/account/SubmissionSuccessPage";
import AdminDashboardPage from "@adminPages/AdminDashboardPage";
import AdminUserSubmissionPage from "@adminPages/AdminUserSubmissionPage";

Vue.use(VueRouter);

Vue.use(VueGtm, {
    id: 'GTM-K7LRRT7', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    loadScript: false, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  });

// Defining the routes
const router = new VueRouter({
    mode: "history",
    linkExactActiveClass: "is-active",
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
                // behavior: "smooth",
            };
        }
        return { x: 0, y: 0 }; // Go to the top of the page if no hash
    },
    routes: [
        {
            path: "/",
            redirect: { name: "register" },
        },
        {
            path: "/login/",
            name: "login",
            component: LoginPage,
            meta: {
                guest: true,
            },
        },
        {
            path: "/register/",
            name: "register",
            component: RegisterPage,
            meta: {
                guest: true,
            },
        },
        {
            path: "/password/forgot/",
            name: "forgot-password",
            component: ForgotPasswordPage,
            meta: {
                guest: true,
            },
        },
        {
            path: "/password/reset/",
            name: "password-reset",
            component: PasswordResetPage,
            meta: {
                guest: true,
            },
        },
        {
            path: "/email-verified/",
            name: "email-verified",
            component: EmailVerifiedPage,
            meta: {
                guest: true,
            },
        },
        {
            path: "/create/:step/",
            name: "create-account",
            component: CreateAccountPage,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/success",
            name: "submission-success",
            component: SubmissionSuccessPage,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/admin",
            name: "admin-dashboard",
            component: AdminDashboardPage,
            meta: {
                isAdmin: true,
            },
        },
        {
            path: "/admin/submission/:user",
            name: "admin-user-submission",
            component: AdminUserSubmissionPage,
            meta: {
                isAdmin: true,
            },
        },
        {
            path: "*",
            name: "not-found",
            component: Error404Page, // 404
        },
    ],
});

// Route Guards
router.beforeEach((to, from, next) => {
    // Auth
    if (to.matched.some((record) => record.meta.isAdmin)) {
        if (!store.state.user.user.access_token) {
            router.push({
                path: "/login/",
                params: { nextUrl: to.fullPath },
            });
        } else {
            next();
        }
    }
    // Auth
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (!store.state.user.user.access_token) {
            router.push({
                path: "/login/",
                params: { nextUrl: to.fullPath },
            });
        } else {
            next();
        }
    }
    // Guest
    else if (to.matched.some((record) => record.meta.guest)) {
        if (!store.state.user.user.access_token) {
            next();
        } else {
            router.push({
                path: "/create/1/",
                params: { nextUrl: to.fullPath },
            });
        }
    } else {
        next();
    }
});

export default router;
